import usePostData from '../../../../../hooks/postHook';

export const useUpdateUserName = ({ brandId, clientId }) => {
  const [{ body, isLoading, isError, error }, doUpdateUserName] = usePostData(
    `admin_brand/${brandId}/client/${clientId}/username`
  );

  return { body, isLoading, isError, error, doUpdateUserName };
};
